import { useEffect, useState } from "react";
import { useMantineTheme } from "@mantine/core";
import { ChevronRight } from "@/public/icons/ChevronRight";
import HydratedMediaQuery from "@/utils/hydratedMediaQuery";
import { getBreakpoint } from "@/utils/mantine";
import { Card, CardContent } from "./card/Card";
import styles from "./CardCarrousel.module.scss";

export type CardCarrouselProps = {
  title: string;
  urlPrefix: string;
  cards: CardContent[];
};

export const CardCarrousel = ({
  title,
  urlPrefix,
  cards,
}: CardCarrouselProps) => {
  const theme = useMantineTheme();
  const isTabletOrDesktop = HydratedMediaQuery(
    getBreakpoint(theme.breakpoints.md)
  );

  const MAX_CARD_SHOWING = 3;

  const indexes = Array(Math.ceil(cards.length / MAX_CARD_SHOWING)).fill(null);

  const showArrows = {
    topLeft: cards.length > MAX_CARD_SHOWING && isTabletOrDesktop,
    bottomLeft: cards.length > MAX_CARD_SHOWING && !isTabletOrDesktop,
    right: cards.length > MAX_CARD_SHOWING,
  };
  const [carrouselIndex, setCarrouselIndex] = useState(0);
  const [displayedDepartmentCards, setDisplayedDepartmentCards] = useState<
    { name: string; slug: string }[]
  >([]);

  const changeCurrentIndex = (isNext: boolean) => {
    if (isNext) {
      if (carrouselIndex + 1 > indexes.length - 1) {
        setCarrouselIndex(0);
      } else {
        setCarrouselIndex(carrouselIndex + 1);
      }
    } else {
      if (carrouselIndex - 1 < 0) {
        setCarrouselIndex(indexes.length - 1);
      } else {
        setCarrouselIndex(carrouselIndex - 1);
      }
    }
  };

  useEffect(() => {
    setDisplayedDepartmentCards(
      cards.slice(
        carrouselIndex * MAX_CARD_SHOWING,
        carrouselIndex * MAX_CARD_SHOWING + MAX_CARD_SHOWING
      )
    );
  }, [cards, carrouselIndex]);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.carrouselContainer}>
        {showArrows.topLeft && (
          <div
            className={styles.chevronLeft}
            onClick={() => {
              changeCurrentIndex(false);
            }}
          >
            <ChevronRight />
          </div>
        )}

        <div className={styles.cardsContainer}>
          {displayedDepartmentCards.map((department, index) => (
            <Card
              name={department.name}
              slug={department.slug}
              urlPrefix={urlPrefix}
              key={index}
            />
          ))}

          <noscript>
            {cards.map((card, index) => (
              <Card
                name={card.name}
                slug={card.slug}
                urlPrefix={urlPrefix}
                key={index}
              />
            ))}
          </noscript>
        </div>

        <div className={styles.chevronsDown}>
          {showArrows.bottomLeft && (
            <div
              className={styles.chevronLeft}
              onClick={() => {
                changeCurrentIndex(false);
              }}
            >
              <ChevronRight />
            </div>
          )}

          {showArrows.right && (
            <div
              className={styles.chevronRight}
              onClick={() => {
                changeCurrentIndex(true);
              }}
            >
              <ChevronRight />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
